import React from 'react';
import { FiAlertTriangle, FiZap } from 'react-icons/fi';
import { FeedbackType } from './ClosedBetaWizard';

interface StepTypeProps {
  onSelect: (type: FeedbackType) => void;
}

export const StepType: React.FC<StepTypeProps> = ({ onSelect }) => {
  return (
    <div className="p-6">
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        What type of feedback would you like to provide?
      </p>
      
      <div className="space-y-4">
        {/* Bug Report Option */}
        <button
          onClick={() => onSelect('BUG')}
          className="w-full p-6 border-2 border-gray-200 dark:border-gray-700 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 transition-colors text-left group"
        >
          <div className="flex items-start gap-4">
            <div className="p-2 bg-red-100 dark:bg-red-900 rounded-lg group-hover:bg-red-200 dark:group-hover:bg-red-800 transition-colors">
              <FiAlertTriangle className="w-6 h-6 text-red-600 dark:text-red-400" />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-1">
                Bug / Issue Report
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Report a problem, error, or unexpected behavior you've encountered
              </p>
            </div>
          </div>
        </button>

        {/* Feature Suggestion Option */}
        <button
          onClick={() => onSelect('SUGGESTION')}
          className="w-full p-6 border-2 border-gray-200 dark:border-gray-700 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 transition-colors text-left group"
        >
          <div className="flex items-start gap-4">
            <div className="p-2 bg-yellow-100 dark:bg-yellow-900 rounded-lg group-hover:bg-yellow-200 dark:group-hover:bg-yellow-800 transition-colors">
              <FiZap className="w-6 h-6 text-yellow-600 dark:text-yellow-400" />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-1">
                Feature Suggestion
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Suggest a new feature or improvement to make the app better
              </p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}; 